import { ConfigProvider } from "antd";
import AuthRoutes from "./routes/authRoutes.jsx";
import { Auth0Provider } from "@auth0/auth0-react";
import { App as AppProvier } from "antd";
import { StrictMode, useRef } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import FloatingQR from "./components/FloatingQR";

const queryClient = new QueryClient();

export default function App() {
  const modalContainerRef = useRef(null);
  return (
    <ConfigProvider
      theme={{
        hashed: false,
        token: { colorPrimary: "#A52527" },
        components: {
          Table: {
            colorFillAlter: "rgba(0, 0, 0, 0.06)",
            fontWeightStrong: 700,
          },
        },
      }}
      getPopupContainer={() => modalContainerRef.current}
    >
      <QueryClientProvider client={queryClient}>
        <AppProvier>
          <div
            ref={modalContainerRef}
            className="App"
            style={{ overflowX: "hidden" }}
          >
            <StrictMode>
              <Auth0Provider
                domain={import.meta.env.VITE_AUTH0_DOMAIN}
                clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
                authorizationParams={{
                  redirect_uri: window.location.origin + "/care",
                  audience: import.meta.env.VITE_AUTH0_AUDIENCE,
                }}
                //  useRefreshTokens: true, https://community.auth0.com/t/how-to-use-refresh-tokens-in-react/138658
              >
                <AuthRoutes />
                <FloatingQR />
              </Auth0Provider>
            </StrictMode>
          </div>
        </AppProvier>
      </QueryClientProvider>
    </ConfigProvider>
  );
}
